import { IFlowEventData } from 'types/analytics';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const HEADER_ANALYTICS_ATTRIBUTES: Omit<IFlowEventData, 'flowType'> = {
    location: 'header',
    category: CATEGORY.INTERACTION,
    action: 'go to Ubisoft.com'
};
